export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-selection/src/constant.js
// module id = KG71
// module chunks = 0